import { useEffect, useState } from "react";

export const useAlert = () => {
  const [alertState, setAlertState] = useState({
    show: false,
    labelText: "",
    failure: false,
    status: "Success",
    type: "",
  });

  const closeAlert = () => {
    setAlertState({ ...alertState, show: false });
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        closeAlert();
      }, 4000);
    }
    return () => {};
  }, [alertState]);

  return {
    alertState,
    setAlertState,
    closeAlert,
  };
};
